import { render, staticRenderFns } from "./packetQuery.vue?vue&type=template&id=40ca5b66&scoped=true"
import script from "./packetQuery.vue?vue&type=script&lang=js"
export * from "./packetQuery.vue?vue&type=script&lang=js"
import style0 from "./packetQuery.vue?vue&type=style&index=0&id=40ca5b66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca5b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ca5b66')) {
      api.createRecord('40ca5b66', component.options)
    } else {
      api.reload('40ca5b66', component.options)
    }
    module.hot.accept("./packetQuery.vue?vue&type=template&id=40ca5b66&scoped=true", function () {
      api.rerender('40ca5b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/packetQuery.vue"
export default component.exports